<template>
    <section class="drawer">
        <!-- 로그인 전 -->
        <aside class="mdc-drawer mdc-drawer--modal">
            <div>
                <div class="pda-default">
                    <div :style="brandLogo ? `background-image: url(${brandLogo});` : ''" class="drawer-profile-logo"></div>
                </div>
                <div class="mdc-drawer__header  mgt-5">
                    <div class="t-headline7">
                        {{brandName}}
                    </div>
                </div>
            </div>

            <div class="mdc-drawer__content">
                <nav class="mdc-list">
                    <hr class="mdc-list-divider">
                    <!-- 강의 목록 -->
                    <drawer-lecture-list></drawer-lecture-list>
                    <hr class="mdc-list-divider">

                    <h6 class="mdc-list-group__subheader t-body4">
                        {{$t('232')}}
                        <!-- 멤버십 -->
                    </h6>                    
                    <router-link class="mdc-list-item" to="/login">
                        <i class="material-icons mdc-list-item__graphic">inbox</i>
                        {{$t('233')}}
                        <!-- 로그인 -->
                    </router-link>
                    <router-link class="mdc-list-item" to="/join2/intro">
                        <i class="material-icons mdc-list-item__graphic">inbox</i>
                        {{$t('234')}}
                        <!-- 회원가입 -->
                    </router-link>

                    <hr class="mdc-list-divider">
                    <div>
                        <h6 class="mdc-list-group__subheader t-body4">
                            {{$t('235')}}
                            <!-- 설정 -->
                        </h6>
                        <drawer-language @closeDrawer="closeDrawer"></drawer-language>
                        <router-link class="mdc-list-item" to="/">
                            <i class="material-icons mdc-list-item__graphic">inbox</i>
                            {{$t('108')}}
                            <!-- 서비스 선택 -->
                        </router-link>
                    </div>
                </nav>
            </div>
        </aside>
        <div class="mdc-drawer-scrim"></div>
    </section>
</template>

<script>
/**
 * 네비게이션 드로워 게스트 컴포넌트(navigation drawer guest Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBarDrawerLanguage from './TopAppBarDrawerLanguage.vue'
import TopAppBarDrawerLectureList from './TopAppBarDrawerLectureList.vue'

export default {
    props: ['isDrawerOpen'],
    components: {
        'drawer-language': TopAppBarDrawerLanguage, 
        'drawer-lecture-list': TopAppBarDrawerLectureList
    },
    
    data() {
        return {
            token: localStorage.getItem('token'),
            brandLogo: localStorage.getItem('brandLogo'),
            brandName: localStorage.getItem('brandName'),
            drawer: null,
            drawerList: null,
        }
    },

    methods: {
        closeDrawer() {
            this.$emit('closeDrawer')
        },
       
    }
}
</script>